import * as React from 'react'

import {
  Button,
  Modal,
  Space,
  TextBody,
  TextHeading,
  useModalContext,
} from '@ally/metronome-ui'

import { ImageWrapper } from '../Components/Shared'
import vinId from '../assets/images/vin-id.jpg'

const headingRef = React.createRef<HTMLHeadingElement>()

const ModalContent: React.FC = () => {
  const altText =
    'You can find your VIN/Hull ID under Account Information on your most recent billing statement.'

  return (
    <>
      <Space mb="md">
        <TextHeading
          data-testid="vin-modal-header"
          ref={headingRef}
          size="md"
          tabIndex={-1}
          tag="h1"
        >
          Where to find your VIN
        </TextHeading>
      </Space>

      <Space mb="lg">
        <TextBody tag="p" size="md">
          For auto financing, your 17-character{' '}
          <b>Vehicle Identification Number</b> can be found in a number of
          places: on your most recent billing statement, on insurance documents,
          on your contract or purchase agreement, or on the inside of your
          windshield.
        </TextBody>
      </Space>

      <Space mb="md">
        <ImageWrapper>
          <img alt={altText} src={vinId} />
        </ImageWrapper>
      </Space>

      <Space mb="md">
        <TextBody tag="p" size="md">
          For trailers, your VIN can also be found on the manufacturer&apos;s
          plate, which is usually near the front of the driver&apos;s side.
        </TextBody>
      </Space>

      <Space mb="md">
        <TextBody tag="p" size="md">
          For boat financing, your <b>Hull ID</b> is 12 or 14 characters
          (including leading zeroes) and can be found in your contract or on
          your most recent billing statement.
        </TextBody>
      </Space>
    </>
  )
}

const ModalTriggerComponent: React.FC<{ allytmln: string }> = ({
  allytmln,
}) => {
  const { setOpen } = useModalContext()

  return (
    <Button
      allytmln={allytmln}
      data-testid="vin-modal-trigger"
      onClick={(): void => setOpen(true)}
      text="Where to find your VIN"
      variant="link"
    />
  )
}

export const FindVINModal: React.FC<{ allytmln?: string }> = ({
  allytmln = 'whereToFindYourVin',
}) => (
  <Modal
    content={<ModalContent />}
    trigger={<ModalTriggerComponent allytmln={allytmln} />}
  />
)
